exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".t-fade{display:block}.t-fade-enter{opacity:0;transition:opacity .3s}.t-fade-enter-active{opacity:1}.t-fade-leave{z-index:0;opacity:1;transition:opacity .3s;transition-delay:.2s}.t-fade-leave-active{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/GoalsPage/Specials.scss
// module id = 677
// module chunks = 5